export default function DateSeparator({ date }: Readonly<{ date: string }>) {
  return (
    <div className="flex items-center justify-center mb-4">
      <span className="text-xs font-semibold text-ss-neutral-600 bg-transparent px-3 py-2">
        {date}
      </span>
    </div>
  )
}
